if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(129|243|573|76|880)|2(248|354|662|887)|3(270|314|396|634|700)|4(506|658|665|72|782)|5((71|75|83)4|278|946|971)|6(088|378|456|660)|8(224|27|469|536|782|918)|9(121|229|833|962)|7762|7898)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}